module.exports = __webpack_public_path__ + "img/cigarette-intake-no.fe2378cc.svg";